import type { PropsWithChildren } from 'react';
import { ScheduleBoardContextProvider } from 'pos-client/components/scheduleBoard/context/ScheduleBoardContext.tsx';
import { ClientProvider } from 'pos-client/contexts/ClientContext.tsx';
import { NavigationPermissionProvider } from 'pos-client/contexts/navigationPermissionProvider.tsx';
import { NotificationsContextProvider } from 'pos-client/contexts/NotificationsContext.tsx';
import { StoreAccountingProvider } from 'pos-client/contexts/StoreAccountingContext.tsx';
import { initializeDatadog } from 'pos-client/datadog/Datadog.ts';
import { DatadogUserTracking } from 'pos-client/datadog/DatadogUserTracking.tsx';
import { ThemeProvider } from 'pos-client/theme/ThemeProvider.tsx';

import { TrpcQueryProvider } from './TrpcQueryProvider.tsx';

initializeDatadog();

// Use for all contexts that need to wrap the app root
export const AppProvider = ({ children }: PropsWithChildren) => (
  <ThemeProvider>
    <NotificationsContextProvider>
      <TrpcQueryProvider>
        <DatadogUserTracking />
        <NavigationPermissionProvider>
          <ClientProvider>
            <StoreAccountingProvider>
              <ScheduleBoardContextProvider>
                {children}
              </ScheduleBoardContextProvider>
            </StoreAccountingProvider>
          </ClientProvider>
        </NavigationPermissionProvider>
      </TrpcQueryProvider>
    </NotificationsContextProvider>
  </ThemeProvider>
);
